import * as uuid from 'uuid';

export const generateUuidChatbot = (uuidString = null, index = 0) => {
  if (uuidString) {
    const uuidRaw = uuidString.replace(/ - \d+$/, '');
    const dst = uuidRaw + ` - ${index}`;
    window.localStorage.setItem('uuid', dst);
    return dst;
  }
  const dst =  `${uuid.v4()} - ${index}`;
  window.localStorage.setItem('uuid', dst);
  return dst;
}

export const removeUuidChatbot = () => {
  window.localStorage.removeItem('uuid');
}
